import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Button } from 'foundations-components/transitional/components/Button';
import { ExpandableSection } from 'foundations-components/transitional/components/ExpandableSection';
import { ResultsMessage } from 'foundations-components/transitional/components/ResultsMessage';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { View } from 'foundations-components/transitional/components/View';
import _get from 'hs-lodash/get';
import { useState } from 'react';
import SuggestionsList from './SuggestionsList';
import { InfoIcon } from 'foundations-assets/icons/components/InfoIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const NUMBER_OF_VISIBLE_CONTACTS = 3;
const SuggestionsListSection = ({
  contacts,
  contactToAssociate,
  selectContact,
  defaultSearchValue,
  appName
}) => {
  const [showAll, setShowAll] = useState(false);
  return /*#__PURE__*/_jsxs(ExpandableSection, {
    defaultOpen: true,
    titleText: /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "associationsPanel.tabs.associate.suggestion"
      }), /*#__PURE__*/_jsx(Tooltip, {
        title: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "associationsPanel.tabs.associate.suggestionTooltip",
          options: {
            searchValue: defaultSearchValue
          }
        }),
        children: /*#__PURE__*/_jsx(View, {
          marginInlineStart: "100",
          as: "span",
          children: /*#__PURE__*/_jsx(InfoIcon, {
            size: "300"
          })
        })
      })]
    }),
    children: [contacts.length ? /*#__PURE__*/_jsx(SuggestionsList, {
      contactToAssociateId: _get(contactToAssociate, 'id', '').toString(),
      contacts: showAll ? contacts : contacts.slice(0, NUMBER_OF_VISIBLE_CONTACTS),
      selectContact: selectContact
    }) : /*#__PURE__*/_jsx(ResultsMessage, {
      illustration: "empty-state-charts",
      illustrationProps: {
        width: 100
      },
      margin: "100",
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        "data-test-id": `${appName}-suggestionNoResults`,
        message: "associationsPanel.tabs.associate.suggestionNoResults",
        options: {
          searchValue: defaultSearchValue
        }
      })
    }), contacts.length > NUMBER_OF_VISIBLE_CONTACTS && /*#__PURE__*/_jsx(Button, {
      use: "transparent",
      responsive: false,
      onClick: () => setShowAll(!showAll),
      paddingInline: "0",
      role: "button",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `associationsPanel.tabs.associate.show${showAll ? 'Less' : 'All'}`,
        options: {
          count: contacts.length
        }
      })
    })]
  });
};
export default SuggestionsListSection;